module.exports = __webpack_public_path__ + "img/partners-logo-descktop.746756d8.svg";